import LengthUnits from 'config/length-units';
import SmallLengthUnits from 'config/small-length-units';
import ForceUnits from 'config/force-units';
import {soilTestUnit} from 'config/soil-test-units';
import * as DEFAULTS from 'reducers/projects/defaults';

export function normalizeSettings(projectSettings={}) {
  projectSettings = projectSettings || {};

  const {
    lengthUnit: {value:lengthUnitType}={}, smallLengthUnit: {value:smallLengthUnitType}={},
    forceUnit: {value:forceUnitType}={}, testUnit: {value:SoilTestUnitType}={},
    ...settings
  } = projectSettings;

  const {
    system:defaultSystem,
    lengthUnit,
    forceUnit,
    smallLengthUnit,
    testUnit,
    ...defaults
  } = DEFAULTS.SETTINGS;

  const system = settings.system || defaultSystem;

  return {
    ...defaults,
    ...settings,
    system,
    pile: {...DEFAULTS.PILE, ...settings.pile},
    lengthUnit: LengthUnits[lengthUnitType] || lengthUnit,
    smallLengthUnit: SmallLengthUnits[smallLengthUnitType] || SmallLengthUnits[lengthUnitType] || smallLengthUnit,
    forceUnit: ForceUnits[forceUnitType] || forceUnit,
    testUnit: soilTestUnit(SoilTestUnitType || testUnit.value, system)
  };
}

function normalizeLoads(loads) {
  return _.map(loads, (load) => ({
    pileType: load.product ? "push_pier" : "helical",
    ...load
  }))
}

export function normalizeData(initialData={}) {
  initialData = initialData || {};

  const {loads, ...data} = initialData;
  return {
    ...DEFAULTS.DATA,
    ...data,
    loads: loads ? normalizeLoads(loads) : [DEFAULTS.LOAD]
  };
}

export function normalizeProject(project={}) {
  return {
    ...DEFAULTS.PROJECT,
    ...project,
    settings: normalizeSettings(project.settings),
    data: normalizeData(project.data)
  };
};
